import { ADDED, DELETED, LOADED, UPDATED } from "./actionType";

export const added = (bookValue) => {
  return {
    type: ADDED,
    payload: bookValue,
  };
};

export const loaded = (books) => {
  return {
    type: LOADED,
    payload: books,
  };
};

export const updated = (bookId, updatedValue) => {
  return {
    type: UPDATED,
    payload: {
      bookId,
      updatedValue,
    },
  };
};

export const deleted = (bookId) => {
  return {
    type: DELETED,
    payload: bookId,
  };
};
